import { Box, styled } from '@mui/material';
import React from 'react';

interface TableCardProps {
  children: React.ReactNode;
  className?: string;
}

const StyledCard = styled(Box)({
  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
  borderRadius: '16px',
  padding: '24px',
  marginBottom: '24px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
  border: '1px solid rgba(15, 35, 223, 0.1)',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    boxShadow: '0 6px 20px rgba(15, 35, 223, 0.15)',
    transform: 'translateY(-2px)',
  },
});

const TableCard: React.FC<TableCardProps> = ({ children, className }) => {
  return <StyledCard className={className}>{children}</StyledCard>;
};

export default TableCard;
